import React, { FC, ReactNode } from "react"
import { SpeedInsights } from "@vercel/speed-insights/react"

// Shared Components
import SiteFooter from "../site/SiteFooter/SiteFooter"
import SiteFooterSmall from "../site/SiteFooterSmall/SiteFooterSmall"
import SiteNav from "@components/site/SiteNav/SiteNav"

// Sub-components
import Beacon from "@components/Beacon/Beacon"
import FixedCtaBar, { FIXED_CTA_BAR_VARIANTS } from "@components/FixedCtaBar/FixedCtaBar"
import HashHandler from "./components/HashHandler/HashHandler"
import QueryStringHandler from "./components/QueryStringHandler/QueryStringHandler"

// Consts
import {
  USE_SMALL_FOOTER_PATHS,
  HIDE_FOOTER_PATHS,
  INCLUDE_FIXED_CTA_BAR_PATHS_REGEX,
  USE_STATIC_HEADER_PATHS_REGEX,
} from "./Layout.constants"

// Types/interfaces
interface LayoutProps {
  children: ReactNode
  path: string
  template?: string
  useStaticHeader?: boolean
}

interface LayoutInternalVars {
  hideFooter: boolean
  includeFixedCtaBar: boolean
  isHomePage: boolean
  useSmallFooter: boolean
  useStaticHeader: boolean
}

// Component
const Layout: FC<LayoutProps> = ({
  children,
  path,
  useStaticHeader: _useStaticHeader,
}) => {
  const {
    hideFooter,
    includeFixedCtaBar,
    isHomePage,
    useSmallFooter,
    useStaticHeader,
  }: LayoutInternalVars = {
    hideFooter: HIDE_FOOTER_PATHS.includes(path),
    includeFixedCtaBar: !!path.match(INCLUDE_FIXED_CTA_BAR_PATHS_REGEX),
    isHomePage: path === "/",
    useSmallFooter: USE_SMALL_FOOTER_PATHS.includes(path),
    useStaticHeader: _useStaticHeader || !!path.match(USE_STATIC_HEADER_PATHS_REGEX),
  }

  console.log(path)

  return (
    <>
      <HashHandler />
      <QueryStringHandler />
      <SiteNav
        isStatic={useStaticHeader}
        includeLoginButton={isHomePage}
      />
      <main id="main-content">{children}</main>
      {!hideFooter && (useSmallFooter ? <SiteFooterSmall /> : <SiteFooter />)}
      {includeFixedCtaBar && (
        <FixedCtaBar />
      )}
      <Beacon />
      <SpeedInsights />
      {(path === "/" || path === "/pricing/") && (
        <img
          src={`https://accretivemedia.go2cloud.org/aff_i?offer_id=420&aff_id=1&source=${
            // Pricing page
            path === "/pricing/" ? "ty" :
              // Home page
              "lp"
            }`}
          width="0"
          height="0"
          style={{
            position: "absolute",
            visibility: "hidden",
          }}
        />
      )}
    </>
  )
}

export default Layout
